import React, { useEffect, useRef, useState, useCallback } from "react";

import { useHistory, useLocation, useParams } from "react-router";

import { isBefore, isAfter, parse, isValid } from "date-fns";

import { Form, Formik } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";

import { Flex, Button, Box } from "@chakra-ui/react";

import EstatutoEntidade from "./EstatutoEntidade";
import EntidadeGestora from "./EntidadeGestora";
import SupervisaoOGMunicipal from "./SupervisaoOGMunicipal";
import SupervisaoExterna from "./SupervisaoExterna";
import LoadingSpinner from "../../../../components/LoadingSpinner";

import GestaoSAService from "../../../../../main/services/GestaoSAService";
import ServicoAcolhimentoService from "../../../../../main/services/ServicoAcolhimentoService";
import { hasFormChanged } from "../../../../utils/hasFormChanged";
import SemRegistros from "../../../../components/SemRegistros";
import { criancaFunc, servicos } from "../../../../../helpers/Funcionalidades";
import { useAppContext } from "../../../../../Context/MessageContextProvider";
import { useAuthProvider } from "../../../../../Context/AuthProvider";
import { scrollToFieldAnexo } from "../../../../utils/scrollToFIeldAnexo";

const CadastrarGestao = () => {
  const { id } = useParams();
  const history = useHistory();
  const { roleKeycloack, user } = useAuthProvider();
  const { setCadastrarGestaoServ } = useAppContext();
  const suportedFormats = [
    ".png",
    ".bmp",
    ".tiff",
    ".jpg",
    ".jpeg",
    ".doc",
    ".docx",
    ".txt",
    ".dot",
    ".pdf",
    ".xml",
    ".xls",
    ".xlam",
    ".ods",
  ];

  const [dataSA, setDataSA] = useState();
  const [loading, setLoading] = useState(true);
  const [initialValues] = useState({
    possuiEstatuto: "",
    anexoEstatuto: null,
    ultimaAtualizacaoEstatuto: "",
    possuiEntidadeGestora: "",
    entidadesGestoras: [
      {
        id: 0,
        nomeEntidade: "",
        dataInicio: "",
        dataFim: "",
      },
    ],
    listaEntidadeGestora: [
      {
        id: 0,
        nomeEntidade: "",
        dataInicio: "",
        dataFim: "",
      },
    ],
    possuiSupervisaoExterna: "",
    supervisoesExternas: [
      {
        id: 0,
        nomeEntidade: "",
        nomeSupervisor: "",
        dataInicio: "",
        dataFim: "",
      },
    ],
    listaSupervisaoExterna: [
      {
        id: 0,
        nomeEntidade: "",
        nomeSupervisor: "",
        dataInicio: "",
        dataFim: "",
      },
    ],
    possuiSupervisaoOGMunicipal: "",
    supervisoesOGMunicipal: [
      {
        id: 0,
        nomeSupervisor: "",
        dataInicio: "",
        dataFim: "",
      },
    ],
    listaSupervisaoOrgaoGestor: [
      {
        id: 0,
        nomeSupervisor: "",
        dataInicio: "",
        dataFim: "",
      },
    ],
  });

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const idTipoPendencia = searchParams.get("idTipoPendencia");

  const anexoRef = useRef(null);

  const scrollToField = useCallback(
    (ref) => {
      scrollToFieldAnexo(idTipoPendencia, ref);
    },
    [idTipoPendencia],
  );

  useEffect(() => {
    if (["58"].includes(String(idTipoPendencia))) {
      const timeout = setTimeout(() => {
        requestAnimationFrame(() => {
          if (anexoRef.current) {
            scrollToField(anexoRef);
          }
        });
      }, 300);

      return () => clearTimeout(timeout);
    }
  }, [idTipoPendencia, scrollToField]);

  useEffect(() => {
    ServicoAcolhimentoService.getServicoAcolhimento(id)
      .then((res) => {
        setDataSA(res.data);
      })
      .catch((err) => {});

    GestaoSAService.getGestaoSA(id)
      .then((res) => {
        Swal.fire({
          title: "Atenção!",
          text: "Já existe uma Gestão cadastrada para este Serviço de Acolhimento!",
          icon: "warning",
          confirmButtonText: "Fechar",
          confirmButtonColor: "#169499",
        }).then(() => {
          history.push(`/servico-acolhimento/visualizar-gestao/${id}`);
        });
      })
      .catch((erro) => {
        if (erro.response) {
          if (erro.response.data.status !== 404) {
            Swal.fire({
              title: "Atenção!",
              text: "Já existe uma Gestão cadastrada para este Serviço de Acolhimento!",
              icon: "warning",
              confirmButtonText: "Fechar",
              confirmButtonColor: "#169499",
            }).then(() => {
              history.push(`/servico-acolhimento/visualizar-gestao/${id}`);
            });
          } else {
            setLoading(false);
          }
        }
      });
  }, [history, id]);

  const schema = Yup.object().shape({
    possuiEstatuto: Yup.string().test(
      "estatutoObrigatorio",
      "Este campo é obrigatório!",
      (value, context) => {
        if (dataSA) {
          if (dataSA.naturezaServico === "privada") {
            return !!value;
          } else {
            return true;
          }
        } else {
          return false;
        }
      },
    ),
    anexoEstatuto: Yup.mixed().when("possuiEstatuto", {
      is: (possui) => (possui ? possui === "S" : false),
      then: Yup.mixed()
        .required("Este campo é obrigatório!")
        .test("fileSize", "O arquivo tem mais de 10MB.", (value) => {
          if (value === null || dataSA.naturezaServico === "privada") {
            return true;
          } else {
            return value.size <= 10000000;
          }
        })
        .test("fileType", "Anexar uma extensão válida.", (value) => {
          if (value === null || dataSA.naturezaServico === "privada") {
            return true;
          } else {
            let haveFormat = false;
            suportedFormats.forEach((format) => {
              if (value.path.toString().toLowerCase().includes(format)) {
                haveFormat = true;
              }
            });
            return haveFormat;
          }
        }),
    }),
    ultimaAtualizacaoEstatuto: Yup.string()
      .nullable()
      .when("possuiEstatuto", {
        is: (possui) =>
          possui
            ? possui === "S" && dataSA.naturezaServico === "privada"
            : false,
        then: Yup.string("Este campo é obrigatório!")
          .nullable()
          .required("Este campo é obrigatório!")
          .test(
            "dataAtualizacaoAfterToday",
            "A data informada não pode ser uma data futura!",
            (value) => {
              if (value === null) {
                return false;
              } else {
                return !isAfter(
                  parse(value, "dd/MM/yyyy", new Date()),
                  new Date(),
                );
              }
            },
          )
          .test("validDate", "Data inválida!", (value) => {
            if (!!value) {
              if (value.length === 10) {
                return isValid(parse(value, "dd/MM/yyyy", new Date()));
              } else {
                return false;
              }
            } else {
              return false;
            }
          }),
      }),
    possuiEntidadeGestora: Yup.string("Este campo é obrigatório!").required(
      "Este campo é obrigatório!",
    ),
    listaEntidadeGestora: Yup.mixed().when("possuiEntidadeGestora", {
      is: (possui) => (possui ? possui === "S" : false),
      then: Yup.array().of(
        Yup.object().shape({
          nomeEntidade: Yup.string("Este campo é obrigatório!")
            .required("Este campo é obrigatório!")
            .trim("Este campo é obrigatório!"),
          dataInicio: Yup.string("Este campo é obrigatório!")
            .nullable()
            .nullable()
            .required("Este campo é obrigatório!")
            .test(
              "dataAfterToday",
              "A data informada não pode ser uma data futura!",
              (value) => {
                if (value === null) {
                  return false;
                } else {
                  return !isAfter(
                    parse(value, "dd/MM/yyyy", new Date()),
                    new Date(),
                  );
                }
              },
            )
            .test("validDate", "Data inválida!", (value) => {
              if (!!value) {
                if (value.length === 10) {
                  return isValid(parse(value, "dd/MM/yyyy", new Date()));
                } else {
                  return false;
                }
              } else {
                return false;
              }
            }),
          dataFim: Yup.string()
            .nullable()
            .when("dataInicio", (dataInicio, schema) => {
              return schema
                .test(
                  "dataBeforeInicio",
                  "Data de fim não pode ser anterior ao início!",
                  (value) => {
                    if (!Boolean(value)) {
                      return true;
                    } else {
                      return !isBefore(
                        parse(value, "dd/MM/yyyy", new Date()),
                        parse(dataInicio, "dd/MM/yyyy", new Date()),
                      );
                    }
                  },
                )

                .test("validDate", "Data inválida!", (value) => {
                  if (!!value) {
                    if (value.length === 10) {
                      return isValid(parse(value, "dd/MM/yyyy", new Date()));
                    } else {
                      return false;
                    }
                  } else {
                    return true;
                  }
                });
            }),
        }),
      ),
    }),
    possuiSupervisaoExterna: Yup.string("Este campo é obrigatório!").required(
      "Este campo é obrigatório!",
    ),
    listaSupervisaoExterna: Yup.mixed().when("possuiSupervisaoExterna", {
      is: (possui) => (possui ? possui === "S" : false),
      then: Yup.array().of(
        Yup.object().shape({
          nomeEntidade: Yup.string("Este campo é obrigatório!")
            .required("Este campo é obrigatório!")
            .trim("Este campo é obrigatório!"),
          nomeSupervisor: Yup.string("Este campo é obrigatório!")
            .required("Este campo é obrigatório!")
            .trim("Este campo é obrigatório!"),
          dataInicio: Yup.string("Este campo é obrigatório!")
            .nullable()
            .required("Este campo é obrigatório!")
            .test(
              "dataAfterToday",
              "A data informada não pode ser uma data futura!",
              (value) => {
                if (value === null) {
                  return false;
                } else {
                  return !isAfter(
                    parse(value, "dd/MM/yyyy", new Date()),
                    new Date(),
                  );
                }
              },
            )
            .test("validDate", "Data inválida!", (value) => {
              if (!!value) {
                if (value.length === 10) {
                  return isValid(parse(value, "dd/MM/yyyy", new Date()));
                } else {
                  return false;
                }
              } else {
                return false;
              }
            }),
          dataFim: Yup.string()
            .nullable()
            .when("dataInicio", (dataInicio, schema) => {
              return schema
                .test(
                  "dataBeforeInicio",
                  "Data de fim não pode ser anterior ao início!",
                  (value) => {
                    if (!Boolean(value)) {
                      return true;
                    } else {
                      return !isBefore(
                        parse(value, "dd/MM/yyyy", new Date()),
                        parse(dataInicio, "dd/MM/yyyy", new Date()),
                      );
                    }
                  },
                )
                .test("validDate", "Data inválida!", (value) => {
                  if (!!value) {
                    if (value.length === 10) {
                      return isValid(parse(value, "dd/MM/yyyy", new Date()));
                    } else {
                      return false;
                    }
                  } else {
                    return true;
                  }
                });
            }),
        }),
      ),
    }),
    possuiSupervisaoOGMunicipal: Yup.string(
      "Este campo é obrigatório!",
    ).required("Este campo é obrigatório!"),
    listaSupervisaoOrgaoGestor: Yup.mixed().when(
      "possuiSupervisaoOGMunicipal",
      {
        is: (possui) => (possui ? possui === "S" : false),
        then: Yup.array().of(
          Yup.object().shape({
            nomeSupervisor: Yup.string("Este campo é obrigatório!")
              .required("Este campo é obrigatório!")
              .trim("Este campo é obrigatório!"),
            dataInicio: Yup.string("Este campo é obrigatório!")
              .nullable()
              .required("Este campo é obrigatório!")
              .test(
                "dataAfterToday",
                "A data informada não pode ser uma data futura!",
                (value) => {
                  if (value === null) {
                    return false;
                  } else {
                    return !isAfter(
                      parse(value, "dd/MM/yyyy", new Date()),
                      new Date(),
                    );
                  }
                },
              )
              .test("validDate", "Data inválida!", (value) => {
                if (!!value) {
                  if (value.length === 10) {
                    return isValid(parse(value, "dd/MM/yyyy", new Date()));
                  } else {
                    return false;
                  }
                } else {
                  return false;
                }
              }),
            dataFim: Yup.string()
              .nullable()
              .when("dataInicio", (dataInicio, schema) => {
                return schema
                  .test(
                    "dataBeforeInicio",
                    "Data de fim não pode ser anterior ao início!",
                    (value) => {
                      if (!Boolean(value)) {
                        return true;
                      } else {
                        return !isBefore(
                          parse(value, "dd/MM/yyyy", new Date()),
                          parse(dataInicio, "dd/MM/yyyy", new Date()),
                        );
                      }
                    },
                  )
                  .test("validDate", "Data inválida!", (value) => {
                    if (!!value) {
                      if (value.length === 10) {
                        return isValid(parse(value, "dd/MM/yyyy", new Date()));
                      } else {
                        return false;
                      }
                    } else {
                      return true;
                    }
                  });
              }),
          }),
        ),
      },
    ),
  });

  const handleDateParse = (obj, fields = ["dataInicio", "dataFim"]) => {
    const mountedArray = obj.map((objeto) => {
      const tempObj = {};
      for (let key in objeto) {
        if (fields.includes(key)) {
          if (objeto[key]) {
            tempObj[key] = parse(
              objeto[key],
              "dd/MM/yyyy",
              new Date(),
            ).toISOString();
          } else {
            tempObj[key] = null;
          }
        } else {
          tempObj[key] = objeto[key];
        }
      }
      return tempObj;
    });
    return mountedArray;
  };

  const handleSubmit = (values, actions) => {
    setTimeout(() => {
      const {
        possuiEstatuto,
        possuiEntidadeGestora,
        possuiSupervisaoExterna,
        possuiSupervisaoOGMunicipal,
        entidadesGestoras,
        listaEntidadeGestora,
        supervisoesExternas,
        listaSupervisaoExterna,
        supervisoesOGMunicipal,
        listaSupervisaoOrgaoGestor,
        ultimaAtualizacaoEstatuto,
        ...resto
      } = values;

      const valuesToSend =
        dataSA.naturezaServico === "publica"
          ? {
              possuiEntidadeGestora,
              possuiSupervisaoExterna,
              possuiSupervisaoOGMunicipal,
              entidadesGestoras:
                possuiEntidadeGestora === "S"
                  ? JSON.stringify(handleDateParse(listaEntidadeGestora))
                  : "",
              listaEntidadeGestora:
                possuiEntidadeGestora === "S"
                  ? JSON.stringify(handleDateParse(listaEntidadeGestora))
                  : "",
              supervisoesExternas:
                possuiSupervisaoExterna === "S"
                  ? JSON.stringify(handleDateParse(listaSupervisaoExterna))
                  : "",
              listaSupervisaoExterna:
                possuiSupervisaoExterna === "S"
                  ? JSON.stringify(handleDateParse(listaSupervisaoExterna))
                  : "",
              supervisoesOGMunicipal:
                possuiSupervisaoOGMunicipal === "S"
                  ? JSON.stringify(handleDateParse(listaSupervisaoOrgaoGestor))
                  : "",
              listaSupervisaoOrgaoGestor:
                possuiSupervisaoOGMunicipal === "S"
                  ? JSON.stringify(handleDateParse(listaSupervisaoOrgaoGestor))
                  : "",
              ...resto,
            }
          : {
              possuiEstatuto,
              possuiEntidadeGestora,
              possuiSupervisaoExterna,
              possuiSupervisaoOGMunicipal,
              entidadesGestoras:
                possuiEntidadeGestora === "S"
                  ? JSON.stringify(handleDateParse(listaEntidadeGestora))
                  : "",
              listaEntidadeGestora:
                possuiEntidadeGestora === "S"
                  ? JSON.stringify(handleDateParse(listaEntidadeGestora))
                  : "",
              supervisoesExternas:
                possuiSupervisaoExterna === "S"
                  ? JSON.stringify(handleDateParse(listaSupervisaoExterna))
                  : "",
              listaSupervisaoExterna:
                possuiSupervisaoExterna === "S"
                  ? JSON.stringify(handleDateParse(listaSupervisaoExterna))
                  : "",
              supervisoesOGMunicipal:
                possuiSupervisaoOGMunicipal === "S"
                  ? JSON.stringify(handleDateParse(listaSupervisaoOrgaoGestor))
                  : "",
              listaSupervisaoOrgaoGestor:
                possuiSupervisaoOGMunicipal === "S"
                  ? JSON.stringify(handleDateParse(listaSupervisaoOrgaoGestor))
                  : "",
              ultimaAtualizacaoEstatuto: ultimaAtualizacaoEstatuto
                ? parse(
                    ultimaAtualizacaoEstatuto,
                    "dd/MM/yyyy",
                    new Date(),
                  ).toISOString()
                : "",
              ...resto,
            };
      GestaoSAService.novaGestaoSA(id, valuesToSend)
        .then((res) => {
          Swal.fire({
            title: "Sucesso!",
            text: "Registro cadastrado com sucesso!",
            icon: "success",
            confirmButtonText: "Continuar",
            confirmButtonColor: "#169499",
          }).then(function () {
            history.push(`/servico-acolhimento/visualizar-gestao/${id}`);
            setCadastrarGestaoServ(false);
          });
          actions.setSubmitting(false);
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.data) {
              if (error.response.data.message) {
                if (error.response.data.field === "gestao") {
                  Swal.fire({
                    title: "Atenção!",
                    text: error.response.data.message
                      ? JSON.parse(error.response.data.message).gestao
                      : "",
                    icon: "warning",
                    confirmButtonText: "Fechar",
                    confirmButtonColor: "#169499",
                  }).then(() => {});
                } else {
                  const errors = JSON.parse(error.response.data.message);
                  for (let key in errors) {
                    actions.setFieldError(key.toString(), errors[key]);
                  }
                }
              } else if (error.response.data.apierror) {
                if (error.response.data.apierror.subErrors) {
                  error.response.data.apierror.subErrors.forEach((erro) => {
                    actions.setFieldError(erro.field, erro.message);
                  });
                }
              }
            }
          } else {
            console.log(error);
          }
          actions.setSubmitting(false);
        });
    }, 200);
  };
  return roleKeycloack &&
    (roleKeycloack.includes(servicos.gestaoCadastrar) ||
      (roleKeycloack?.includes(criancaFunc.visualizarTudoAcolhimento) &&
        user?.orgaoExterno?.includes(Number(dataSA?.idPessoaJuridica)))) ? (
    dataSA !== undefined && !loading ? (
      <Formik
        validationSchema={schema}
        initialValues={initialValues}
        onSubmit={handleSubmit}
        validateOnChange={false}
        validateOnBlur={false}
      >
        {(props) => (
          <Form>
            <Box
              mt={"15px"}
              border={
                ["58"].includes(idTipoPendencia) ? "3px solid #4299E199" : ""
              }
              ref={anexoRef}
            >
              {dataSA.naturezaServico === "privada" && (
                <EstatutoEntidade
                  formProps={props}
                  mt={
                    dataSA.naturezaServico === "privada" &&
                    ["58"].includes(idTipoPendencia)
                      ? "0px"
                      : "20px"
                  }
                />
              )}
              <EntidadeGestora
                formProps={props}
                mt={
                  dataSA.naturezaServico !== "privada" &&
                  ["58"].includes(idTipoPendencia)
                    ? "0px"
                    : "20px"
                }
              />
              <SupervisaoExterna formProps={props} />

              <SupervisaoOGMunicipal formProps={props} />
              {setCadastrarGestaoServ(
                hasFormChanged(initialValues, props?.values),
              )}
            </Box>
            <Flex mt="30px" justifyContent="flex-end">
              <Button
                id="button-salvar"
                type="submit"
                translate="no"
                color="#FFF"
                backgroundColor="#169499"
                fontWeight={700}
                fontSize="15px"
                lineHeight="21.6px"
                _hover={{ bg: "#169499" }}
                w="17%"
                isLoading={props.isSubmitting}
              >
                Salvar
              </Button>
            </Flex>
          </Form>
        )}
      </Formik>
    ) : (
      <Flex w="100%" mt="25%" justifyContent="center">
        <LoadingSpinner />
      </Flex>
    )
  ) : (
    <Box mt={2}>
      <SemRegistros buttonVisible={true} half />
    </Box>
  );
};

export default CadastrarGestao;
